export class PriceAccpetanceModel{
    grnId:number
    grnNumber:string
    indentNumber:string
    supplierType:string
    supplierName:string
    supplierCode:string
    invoiceNumber:string
    farmerName:string
    grnItemInfo:GrnItemInfoForPriceApproval[]
    billToType?:string
    financierName?: string


    constructor(grnId:number,grnNumber:string,indentNumber:string,supplierType:string,supplierName:string,supplierCode:string,invoiceNumber:string, farmerName:string,grnItemInfo:GrnItemInfoForPriceApproval[],billToType?:string,financierName?:string){
        this.grnId = grnId
        this.grnNumber = grnNumber
        this.indentNumber = indentNumber
        this.supplierType = supplierType
        this.supplierName = supplierName
        this.supplierCode = supplierCode
        this.invoiceNumber = invoiceNumber
        this.grnItemInfo = grnItemInfo
        this.farmerName =farmerName
        this.billToType = billToType
        this.financierName = financierName
    }
}

export class GrnItemInfoForPriceApproval{
    lotNumber:string
    count:number
    quantity:number
    price:number
    totalAmount:number
    batchNumber:string
    remarks:string
    type:string
    defect:string
    approvedPrice?:number
    constructor(lotNumber:string,count:number,quantity:number,price:number,totalAmount:number,batchNumber:string,remarks:string,type:string,defect:string,approvedPrice?:number){
        this.lotNumber = lotNumber
        this.count = count
        this.quantity = quantity
        this.price = price
        this.totalAmount = totalAmount
        this.batchNumber = batchNumber
        this.remarks = remarks
        this.type = type
        this.defect = defect
        this.approvedPrice=approvedPrice

    }
}